// EAGER MySQL sniff walker (bundle-isolation: header reads only — no wkx/decoder import; the
// ONLY in-tree import is `./sniffWalkers`, satisfying the eager renderer-graph isolation rule).
// MySQL geometry wire = 4-byte LE SRID prefix + standard WKB (SPATIAL-FACTS b2/b3): `bytes` here
// is already the CAPPED read handed in by `spatialSniff.ts`'s `runWalkers` (full value when under
// MAX_SNIFF_WALK_BYTES, else just the HEADER_PREFIX_BYTES header) — this file never materializes
// more than what it is given. Reads the SRID from the first 4 bytes (LE), then delegates the WKB
// body (bytes[4:]) to the shared `sniffWkb` walker, overriding `srid` (from the prefix, matching
// the FACTS b2 capture convention: SRID 0 → null) and `container: 'mysql-srid-wkb'` on the result.
import { sniffWkb, type SniffFacts } from './sniffWalkers';

const SRID_PREFIX_BYTES = 4;

export function sniffMysqlWkb(bytes: Uint8Array, walk: boolean, byteLength: number): SniffFacts | null {
  if (bytes.byteLength < SRID_PREFIX_BYTES) return null;
  const dv = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  const rawSrid = dv.getUint32(0, true); // 4-byte LE SRID prefix (SPATIAL-FACTS b2)
  const body = bytes.subarray(SRID_PREFIX_BYTES);
  const facts = sniffWkb(body, walk, byteLength);
  if (!facts) return null;
  return { ...facts, container: 'mysql-srid-wkb', srid: rawSrid === 0 ? null : rawSrid };
}
